import { render } from "./BarraProgresso.vue?vue&type=template&id=56bad63e&scoped=true&ts=true"
import script from "./BarraProgresso.vue?vue&type=script&lang=ts"
export * from "./BarraProgresso.vue?vue&type=script&lang=ts"

import "./BarraProgresso.vue?vue&type=style&index=0&id=56bad63e&scoped=true&lang=css"

import exportComponent from "D:\\UniRH\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56bad63e"]])

export default __exports__